import { gql } from '@apollo/client/core';

export const defaultCardFragment = gql`
  fragment DefaultCardFragment on CatalogCard {
    adult
    favorite
    feedbackQuantity
    id
    minFullPrice
    minSellPrice
    offer {
      due
      icon
      text
      textColor
    }
    badges {
      ... on BottomTextBadge {
        backgroundColor
        description
        id
        link
        text
        textColor
      }
    }
    ordersQuantity
    productId
    rating
    title
    inStock
  }
`;
